export default "__VITE_PUBLIC_ASSET__7c51ca63__"